const style = {
  wrapper: {
    position: `relative`,
    zIndex: 10,
    borderTop: `1px solid #eee`,
    borderBottom: `1px solid #eee`,
    background: `white`,
    boxShadow: `0 4px 0 rgba(0, 0, 0, 0.04)`
  },
  logo: {
    margin: `3px 15px 3px 0`,
    display: `inline-block`,
    maxHeight: `50px`
  },
  collapseButton: {
    color: `white`,
    background: `#333`,
    height: `40px`,
    width: `40px`,
    border: 0
  },
  listWrapper: {
    padding: 0,
    '@media (min-width: 992px)': {
      padding: `0 15px`
    }
  },
  list: {
    listStyle: `none`,
    height: `100%`,
    margin: 0,
    padding: 0
  },
  listItem: {
    position: `relative`,
    color: `#666`,
    margin: 0,
    textAlign: `left`,
    borderBottom: `#eee 1px solid`,
    '@media (min-width: 992px)': {
      textAlign: `center`,
      borderBottom: `none`,
      borderLeft: `#eee 1px solid`,
      ':last-child': {
        borderRight: `#eee 1px solid`
      },
      ':hover': {
        ':before': {
          position: `absolute`,
          display: `block`,
          left: `0`,
          top: `-3px`,
          content: "''",
          height: `2px`,
          width: `100%`,
          background: `#A94545`
        }
      }
    }
  },
  listItemLink: {
    position: `relative`,
    color: `#ccc`,
    padding: `15px 23px`,
    textDecoration: `none`,
    fontSize: `14px`,
    lineHeight: `14px`,
    fontWeight: `300`,
    transition: `all 0.2s`,
    ':hover': {
      color: `#666`
    }
  },
  listItemTitle: {
    color: `#666`,
    textTransform: `uppercase`
  },
  listItemDesc: {
    fontSize: `12px`,
    textTransform: `lowercase`
  },
  dropdownList: {
    top: 58,
    left: 0,
    zIndex: 999,
    position: `absolute`,
    listStyle: `none`,
    background: `white`,
    boxShadow: `rgba(0,0,0,0.2) 0 6px 12px`,
    width: `200px`,
    margin: 0,
    padding: 0,
    '@media (max-width: 991px)': {
      display: `none`
    }
  },
  dropdownListItem: {},
  dropdownlistItemLink: {
    textAlign: `left`,
    textDecoration: `none`,
    textTransform: `uppercase`,
    padding: `10px 15px`,
    fontWeight: `400`,
    color: `#555`,
    fontSize: `12px`,
    borderBottom: `rgba(0,0,0,0.1) 1px solid`,
    ':hover': {
      background: `#A94545`,
      color: `white`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Header/style/navbar.js